export const blockIconsHomeNestDisplayNew = (
	<span className='material-symbols-outlined'>nest_display</span>
);
